import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import ArcHome from './views/ArcHome.vue'
import store from './plugins/store'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => import('./components/dashboard/Dashboard.vue'),
		},
		{
			path: '/registrationReport',
			name: 'registrationReport',
			component: () => import('./components/registration/RegistrationReport.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/guestcard',
			name: 'guestcard',
			component: () => import('./components/guestCardReport/GuestcardReport.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/revenuereport',
			name: 'revenuereport',
			component: () => import('./components/revenueReport/RevenueReport.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('rr', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/participant',
			name: 'participant',
			component: () => import('./components/participantReport/ParticipantTable.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
					// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('pt', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next();
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/admin',
			name: 'admin',
			component: () => import('./components/adminPage/Admin.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('admin', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/');
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/accesstransaction',
			name: 'validitychecker',
			component: () => import('./components/validityChecker/ValidityCheckerReport.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('vc', router.app.$keycloak.token)
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/statistics',
			name: 'statistics',
			component: () => import('./components/statisticReport/StatisticsBafsTourobs.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
					// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('aastat', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/revenuesumreport',
			name: 'revenuesumreport',
			component: () => import('./components/revenueSumReport/RevenueSumReport.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('rsr', router.app.$keycloak.token)
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/profile',
			name: 'profile',
			component: () => import('./components/profile/Profile.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/usermanager',
			name: 'usermanager',
			component: () => import('./components/userManager/UserManager.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('user', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/parking',
			name: 'parking',
			component: () => import('./components/parkingReport/ParkingOverview.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('parking', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/couponcode',
			name: 'couponCodeReport',
			component: () => import('./components/couponCodeReport/couponCodeReport.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('cc', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/powerbi',
			name: 'powerbi',
			component: () => import('./components/powerBI/PowerBI.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('powerbi', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/blsseepass',
			name: 'blsseepass',
			component: () => import('./components/blsSeepassReport/blsSeepassReport.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('blsseepass', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/ubsxmlexport',
			name: 'ubsxmlexport',
			component: () => import('./components/ubsXmlExport/UbsXmlExport.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('ubsxml', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/orderimport',
			name: 'orderimport',
			component: () => import('./components/orderImportTool/OrderImportTool.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('import', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/integratorstate',
			name: 'integratorstate',
			component: () => import('./components/integratorStateTool/IntegratorStateTool.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
						// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('integstate', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/billingengine',
			name: 'billingengine',
			component: () => import('./components/billingEngine/BillingEngineIndex.vue'),
			beforeEnter: async (to, from, next) => {
				if (to.matched.some((record) => record.meta.requiresAuth)) {
					if (router.app.$keycloak.authenticated) {
					// eslint-disable-next-line no-use-before-define
						const isAuthenticated = await requireAuth('be', router.app.$keycloak.token).catch((e) => {
							console.log(e)
						})
						if (!isAuthenticated) next('/')
						else next()
					}
				} else {
					next()
				}
			},
			meta: {
				requiresAuth: true,
			},
		},
	],
})

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (router.app.$keycloak.authenticated) {
			next()
		} else {
			const loginUrl = router.app.$keycloak.createLoginUrl()
			window.location.replace(loginUrl)
		}
	} else {
		next()
	}
})

router.afterEach((to, from) => {
	store.commit('unseenFiles')
})

async function requireAuth(appName, token) {
	// eslint-disable-next-line no-undef
	const res = await axios.get(`${config.baseAPIurl}/dashboard/application`)
	return res.data.map((el) => el.appnameshort).includes(appName)
}

export default router
